import { createSceneReducer } from 'reducers/reducers-util';
import { combineReducers } from 'redux';
import projectsDataReducer from 'components/admin/projects/store/reducers.data';
import projectsUiReducer from 'components/admin/projects/store/reducers.ui';
import newProjectsDataReducer from 'components/admin/projects/creation/store/reducers.data';
import newProjectsUiReducer from 'components/admin/projects/creation/store/reducers.ui';
import projectDetailsDataReducer from 'components/admin/projects/details/store/reducers.data';
import projectDetailsUiReducer from 'components/admin/projects/details/store/reducers.ui';
import projectProposalDataReducer from 'components/admin/projects/details/project-proposal/store/reducers.data';
import projectProposalUiReducer from 'components/admin/projects/details/project-proposal/store/reducers.ui';
import projectDirectoryDataReducer from 'components/admin/projects/details/project-directory/store/reducers.data';
import projectDirectoryUiReducer from 'components/admin/projects/details/project-directory/store/reducers.ui';
import projectMeetingMinutesDataReducer from 'components/admin/projects/details/project-meeting-minutes/store/reducers.data';
import projectMeetingMinutesUiReducer from 'components/admin/projects/details/project-meeting-minutes/store/reducers.ui';
import projectRfiLogDataReducer from 'components/admin/projects/details/project-rfi-log/store/reducers.data';
import projectRfiLogUiReducer from 'components/admin/projects/details/project-rfi-log/store/reducers.ui';
import projectSubmittalLogDataReducer from 'components/admin/projects/details/project-submittal-log/store/reducers.data';
import projectSubmittalLogUiReducer from 'components/admin/projects/details/project-submittal-log/store/reducers.ui';
import projectEmailModalUiReducer from 'components/admin/projects/details/project-email-modal/store/reducers.ui';
import projectEmailModalDataReducer from 'components/admin/projects/details/project-email-modal/store/reducers.data';
import projectDailyReportLogDataReducer from 'components/admin/projects/details/project-daily-report-log/store/reducers.data';
import projectDailyReportLogUiReducer from 'components/admin/projects/details/project-daily-report-log/store/reducers.ui';
import projectDocumentationDataReducer from 'components/admin/projects/details/project-documentation/store/reducers.data';
import projectOpenItemsDataReducer from 'components/admin/projects/details/project-open-items/store/reducers.data';
import projectOpenItemsUiReducer from 'components/admin/projects/details/project-open-items/store/reducers.ui';
import projectCloseoutDataReducer from 'components/admin/projects/details/project-closeout/store/reducers.data';
import usersNotificationModalUiReducer from 'components/shared/pdf-viewer-bluebeam/store/reducers.ui';
import projectSettingsDataReducer from 'components/admin/projects/details/project-settings/store/reducers.data';
import projectCoiExpsDataReducer from 'components/admin/projects/details/project-coi-exps/store/reducers.data';

export default createSceneReducer(
  projectsDataReducer,
  projectsUiReducer,
  combineReducers({
    creation: createSceneReducer(newProjectsDataReducer, newProjectsUiReducer),
    details: createSceneReducer(
      projectDetailsDataReducer,
      projectDetailsUiReducer,
      combineReducers({
        proposal: createSceneReducer(
          projectProposalDataReducer,
          projectProposalUiReducer
        ),
        directory: createSceneReducer(
          projectDirectoryDataReducer,
          projectDirectoryUiReducer
        ),
        meetingMinutes: createSceneReducer(
          projectMeetingMinutesDataReducer,
          projectMeetingMinutesUiReducer
        ),
        rfiLog: createSceneReducer(
          projectRfiLogDataReducer,
          projectRfiLogUiReducer
        ),
        submittalLog: createSceneReducer(
          projectSubmittalLogDataReducer,
          projectSubmittalLogUiReducer
        ),
        emailModal: createSceneReducer(
          projectEmailModalDataReducer,
          projectEmailModalUiReducer
        ),
        dailyReportLog: createSceneReducer(
          projectDailyReportLogDataReducer,
          projectDailyReportLogUiReducer
        ),
        documentation: createSceneReducer(projectDocumentationDataReducer),
        openItems: createSceneReducer(
          projectOpenItemsDataReducer,
          projectOpenItemsUiReducer
        ),
        closeout: createSceneReducer(projectCloseoutDataReducer),
        pdfViewer: createSceneReducer(usersNotificationModalUiReducer),
        settings: createSceneReducer(projectSettingsDataReducer),
        coiExps: createSceneReducer(projectCoiExpsDataReducer),
      })
    ),
  })
);



// WEBPACK FOOTER //
// ./src/components/admin/projects/store/reducers.js